export const APP_CONFIG = Object.freeze({
  brandName: "Digital Indian Market",
  companyName: "Digital Indian Market",
  currency: "INR",
  locale: "en-IN",
  supportEmail: "sales@example.com",
  brandLabel: "Digital Indian Market",
  brandAssets: Object.freeze({
    logo: "/brand/digital-indian-market-logo.png",
    iconMaster: "/brand/digital-indian-market-logo.png",
    icon512: "/brand/digital-indian-market-logo.png",
    icon192: "/brand/digital-indian-market-logo.png",
    appleTouchIcon: "/brand/digital-indian-market-logo.png",
    favicon64: "/brand/digital-indian-market-logo.png",
    favicon32: "/brand/digital-indian-market-logo.png",
  }),
});

export const withBrand = (text) => String(text).replaceAll("{brand}", APP_CONFIG.brandName);

export const normalizeBrandName = (name) =>
  !name || name === "Business" ? APP_CONFIG.brandName : name;

export const normalizeBrandLogoUrl = (url = "") =>
  /^\/brand\/business-(?:icon|favicon|apple-touch-icon)/.test(url) ? "" : url;
